
// => Styling
import styles from './SubBrowse.module.css';

// => Data
import shopItems from '../../../content/shopItems.json';
import cards from '../../../content/cards.json';
import { boosterPacks } from '../../../content/boosterPacks';

// => Components
import ShopItem from '../components/ShopItem';


// ============
// Component
// ============
const SubBrowse = ({
    showDevItems = false,
    currency = 0,
    requestSubtractCurrency = (price) => {},
    requestUnlockCards = (cs) => {},
    requestOpenBoosterPack = (bp) => {},
    unlockedCards,
}) => {

    const filteredShopItems = () => {
        // Just show all items if we want to show dev items too
        if (showDevItems) {
            return shopItems
        }
        // Else, just return all shop items that have the dev flag FALSE
        return shopItems.filter((c) => {
            return c.dev === false
        })
    }

    function buyItem(id) {
        // Check if item id is valid
        if (id === null || id === "") {
            // TODO: error msg
            return
        }
        // Get item data from id
        let item = shopItems.find(e => e.id === id)
        if (!item) {
            // TODO: error msg
            return
        }

        // Check if we have sufficient funds
        if (!canAfford(item.cost)) {
            // TODO: show error msg
            return
        }

        // Subtract currency
        requestSubtractCurrency(item.cost)

        // Get the item effect (decides what to do based on type)
        itemEffect(item)
    }

    function itemEffect(item) {
        // Check if item is valid first
        if (!item) {
            // TODO: show error msg
            return
        }

        // Decide what to do based on item type
        switch(item.type) {
            case "none":
                alert("You bought the item '" + item.id + "'! This is just a test.")
                break
            case "booster":
                // TODO: TODO: TODO:!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
                /*let test = []
                for (let i = 0; i < 5; i++) {
                    test.push(cards.baseBabes[i])
                }
                requestUnlockCards(test)*/
                requestOpenBoosterPack(item.boosterSet, item.boosterCount)
                break

            default:
                return
        }
    }

    function canAfford(cost) {
        return currency >= cost
    }

    const checkAvailability = (item) => {
        if (item.type === 'booster') {
            let set = boosterPacks.find(e => e.id === item.boosterSet)
            return !setFullyUnlocked(set)
        }
        // TODO: other types of shop items here
        return true
    }

    const setFullyUnlocked = (set = boosterPacks[0]) => {
        let pool = set.pool.filter(c => {
            return unlockedCards.includes(c.id) === false
        })
        if (pool) return pool.length === 0
        else return true
        /*
        // Get unlocked cards from that set
        let setUnlockedCards = unlockedCards.filter((f) => set.pool.findIndex(i => i.id === f.id))
        // Check if length of unlocked set cards is the same as set pool length
        console.log("setFullyUnlocked()", setUnlockedCards, set.pool)
        return setUnlockedCards.length >= set.pool.length
        */
    }


    // RENDER
    // ---------
    return(
        <div className={styles.container}>

            <div className={styles.shop}>

                {/* map shop items */}
                {filteredShopItems().map(e =>
                    <ShopItem key={"shop_item_"+e.id}
                            data={e}
                            onRequestBuy={(id)=>buyItem(id)}
                            affordable={canAfford(e.cost)}
                            availability={checkAvailability(e)} />
                )}

                {/* Show message if there are no shop items available */}
                {filteredShopItems().length === 0 &&
                    <div className={styles.emptyMsg}>No items available...</div>
                }

            </div>

        </div>
    )
}


export default SubBrowse